import React from "react";
import "./styles.css";

// Ячейка строки таблицы списка. Прочие пропсы уходят на <td> — таблица подмешивает
// сюда data-label (подпись колонки) для мобильной карточной вёрстки.
export default function ListBodyItem({ className = '', children, ...other }) {
    return <td {...other} className={`table__body-item ${className}`}>{children}</td>;
}
